export const calcCommission = (price, commission, commissionPerc) =>
  commissionPerc ? 0.01 * +commission * price : +commission;

export const calcStatus = (status) => status.toLowerCase().replace(/ /g, "");

export const detailFinder = (details, name) => details.find((detail) => detail.name === name);

export const getAvatar = (avatar) => (avatar === "/assets/user-default.svg" ? null : avatar);
